import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
const UIView = MojitoCore.Presentation.UIView;
import MyAccountPageViewImpl from './my-account-page-view.js';

/**
 * View that layouts my account page.
 *
 * @class MyAccountPageView
 * @memberof Mojito.Applications.Sports.Pages.MyAccountPage
 */

/**
 * MyAccountPageView prop types.
 *
 * @property {string} [itemId] - The account page item ID.
 * @property {string} [partId] - The subpage details ID.
 *
 * @memberof Mojito.Applications.Sports.Pages.MyAccountPage.MyAccountPageView
 */
const propTypes = {
    itemId: PropTypes.string,
    partId: PropTypes.string,
};

export default UIView('MyAccountPageView', MyAccountPageViewImpl, propTypes);
